import React, { Component } from "react";
import Header from "components/Header/Header";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Footer from "components/Footer/Footer.js";
import { Switch, Route, Redirect } from "react-router-dom";
import router from "../../routes/studentRoutes";
import "assets/scss/material-kit-react.scss?v=1.8.0";
import ssoAuth from "../../hoc/ssoAuth";
import Axios from "config/axios";
import withErrorHandler from "hoc/withErrorHandler";

class Student extends Component {
  state = {
    heightHeader: 400,
    setting: {
      no_hp1: "",
      no_hp2: "",
    },
  };

  componentDidMount() {
    this.setHeaderHeight();
    this.fetchSettings();
  }

  componentDidUpdate(prevState) {
    if (this.props.location.pathname !== prevState.location.pathname) {
      this.setHeaderHeight();
    }
  }

  setHeaderHeight = () => {
    if (this.props.location.pathname !== "/") {
      this.setState({ heightHeader: 50 });
    } else {
      this.setState({ heightHeader: 400 });
    }
  };

  fetchSettings = async () => {
    const unit = await Axios.get("/faculty?nim=" + this.props.user.identity);
    const setting = await Axios.get(
      "/letterhead?unit_id=" + unit.data.new_kode
    );
    if (setting.data.payload.length > 0) {
      this.setState({ setting: setting.data.payload[0] });
    }
  };

  render() {
    const { ...rest } = this.props;

    return (
      <div>
        <Header
          color="transparent"
          rightLinks={<HeaderLinks {...rest} />}
          fixed
          changeColorOnScroll={{
            height: this.state.heightHeader,
            color: "success",
          }}
          {...rest}
        />
        <Switch>
          {router.map((nav, index) => {
            return (
              <Route
                key={index}
                path={nav.path}
                render={(props) => (
                  <nav.component {...props} user={this.props.user} />
                )}
                exact={nav.exact}
              />
            );
          })}
          <Redirect from="*" to="/404" />
        </Switch>
        <Footer setting={this.state.setting} />
      </div>
    );
  }
}

export default ssoAuth(withErrorHandler(Student, Axios), 2);
